<template>
    <b-card
     bg-variant="light"
     id="selected-box"
     class="shadow border-primary"
     no-body
    >
      <div class="d-flex">
        <div class="p-3"><p class="mb-0"><b-badge variant="primary">{{ results.length }}</b-badge> - <b>Pachete selectate</b></p></div>
        <b-btn  class="p-3" variant="primary" size="sm" @click="$emit('info')">Genereaza Oferta</b-btn>
        <b-btn variant="outline-danger" class="btn-sm p-3 border-0" @click="$emit('hide')" >
          <b-icon icon="x"/>
        </b-btn>
      </div>
      <!-- <ul class="list-inline mb-0">
        <li class="list-inline-item">
          <p class="mb-0"><b-badge variant="primary">{{ results.length }}</b-badge> - <b>Pachete selectate</b></p>
        </li>
        <li class="list-inline-item">
          <b-btn variant="warning" size="sm" @click="$emit('info')">Genereaza Oferta</b-btn>
        </li>
        <li class="list-inline-item">
          <b-btn variant="outline-secondary" class="btn-sm close" @click="$emit('hide')">
            <b-icon icon="x"/>
          </b-btn>
        </li>
      </ul> -->
    </b-card>
</template>

<script>
export default {
  name: 'selectedResults',
  props: ['results']
}
</script>

<style lang="scss" scoped>
  #selected-box {
    .btn-primary {
      border-radius:0px;
    }
    .btn-outline-danger {
      border-top-left-radius:0px;
      border-bottom-left-radius:0px;
    }
  }
</style>
